import { render, staticRenderFns } from "./floatingBannerDetail.vue?vue&type=template&id=0834441c&scoped=true"
import script from "./floatingBannerDetail.vue?vue&type=script&lang=js"
export * from "./floatingBannerDetail.vue?vue&type=script&lang=js"
import style0 from "./floatingBannerDetail.vue?vue&type=style&index=0&id=0834441c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0834441c",
  null
  
)

export default component.exports